import { useState } from "react";
import { api } from "../api";
import { IconLogo } from "../components/icons";
import type { AuthUser } from "../types";

/**
 * Показывается сразу после входа с временным паролем. Пока пароль не сменён,
 * сервер не отдаёт никаких данных — это не просто ширма в интерфейсе.
 */
export function ChangePasswordPage({
  user,
  onDone,
  onSignOut,
}: {
  user: AuthUser;
  onDone: (u: AuthUser) => void;
  onSignOut: () => void;
}) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [repeat, setRepeat] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const tooShort = next.length > 0 && next.length < 8;
  const mismatch = repeat.length > 0 && next !== repeat;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (next !== repeat) {
      setError("Новый пароль и подтверждение не совпадают");
      return;
    }
    setBusy(true);
    setError("");
    try {
      onDone(await api.changePassword(current, next));
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
      setBusy(false);
    }
  };

  return (
    <div className="auth-screen">
      <form className="auth-card" onSubmit={submit}>
        <div className="auth-brand">
          <span className="logo-mark"><IconLogo /></span>
          <span>ELG Meeting Hub</span>
        </div>
        <h1>Смените пароль</h1>
        <p className="muted small" style={{ marginTop: -6, marginBottom: 20 }}>
          Вы вошли как <strong>{user.login}</strong> с временным паролем. Придумайте
          постоянный — без этого сервис не откроется.
        </p>

        <div className="field">
          <label htmlFor="cur">Текущий пароль</label>
          <input
            id="cur"
            type="password"
            autoComplete="current-password"
            autoFocus
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            required
          />
        </div>

        <div className="field">
          <label htmlFor="new">Новый пароль</label>
          <input
            id="new"
            type="password"
            autoComplete="new-password"
            value={next}
            onChange={(e) => setNext(e.target.value)}
            required
          />
          <div className={`small ${tooShort ? "error-text" : "muted"}`} style={{ marginTop: 4 }}>
            Не короче 8 символов.
          </div>
        </div>

        <div className="field">
          <label htmlFor="rep">Ещё раз новый пароль</label>
          <input
            id="rep"
            type="password"
            autoComplete="new-password"
            value={repeat}
            onChange={(e) => setRepeat(e.target.value)}
            required
          />
          {mismatch && <div className="error-text">Пароли не совпадают</div>}
        </div>

        {error && <div className="banner red" style={{ marginBottom: 14 }}>{error}</div>}

        <button
          className="primary"
          type="submit"
          disabled={busy || tooShort || mismatch || !next}
          style={{ width: "100%" }}
        >
          {busy && <span className="spinner" />} Сохранить и продолжить
        </button>

        <button
          type="button"
          className="ghost"
          onClick={onSignOut}
          style={{ width: "100%", marginTop: 8 }}
        >
          Выйти
        </button>
      </form>
    </div>
  );
}
